const colors = {
  primaryColor: '0033CC',
  gray: 'C4C4C4',
  lightGray: 'dedede',
  black: '4D4D4D',
  disabledButton: 'DCDCDC',
  white: 'FFFFFF',
  disabledText: 'BABABA',
  backgroundLightGray: 'F7F7F7',
  lightGray2: 'rgba(67, 67, 67, 0.6)',
  timezoneGray: '979797',
  secondaryColor: 'E6EEFF',
  blackText: '3A435F',
  successText: '24C3A2',
  borderGray: 'EDEDED'
}

export default colors;